import React from "react";
import {
  Box,
  Folder2Icon,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MoreVerticalIcon,
  Paper,
  Stack,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const ListItemStartEndICon = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          List Item StartIcon and secondary action in the end
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          language="js"
          background
          title={
            "A checkbox can either be a primary action or a secondary action."
          }
          value={
            "" +
            "             <List>\n" +
            "              {[0, 1, 2, 3].map((value) => {\n" +
            "                return (\n" +
            "                  <ListItem\n" +
            "                    key={value}\n" +
            "                    secondaryAction={\n" +
            '                      <IconButton edge="end">\n' +
            '                        <MoreVerticalIcon fontSize={"small"} />\n' +
            "                      </IconButton>\n" +
            "                    }\n" +
            "                    disablePadding\n" +
            "                  >\n" +
            "                    <ListItemButton role={undefined}>\n" +
            "                      <ListItemIcon>\n" +
            '                        <Folder2Icon color={"action"} fontSize={"small"}/>\n' +
            "                      </ListItemIcon>\n" +
            "                      <ListItemText primary={`Line item ${value + 1}`} />\n" +
            "                    </ListItemButton>\n" +
            "                  </ListItem>\n" +
            "                );\n" +
            "              })}\n" +
            "            </List>"
          }
        >
          <Paper p={3} elevation={0} sx={{ width: 250 }}>
            <List>
              {[0, 1, 2, 3].map((value) => {
                return (
                  <ListItem
                    key={value}
                    secondaryAction={
                      <IconButton edge="end">
                        <MoreVerticalIcon fontSize={"small"} />
                      </IconButton>
                    }
                    disablePadding
                  >
                    <ListItemButton role={undefined}>
                      <ListItemIcon>
                        <Folder2Icon color={"action"} fontSize={"small"} />
                      </ListItemIcon>
                      <ListItemText primary={`Line item ${value + 1}`} />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          </Paper>
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default ListItemStartEndICon;
